var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgTimeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 38,
    viewBox: "0 0 38 38",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11656_14543)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip1_11656_14543)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M36.55 19.2751C36.55 27.3493 30.0155 33.9213 21.9789 33.9213C19.0121 33.9213 16.158 33.02 13.717 31.3676C13.041 30.8794 12.8532 29.9781 13.3414 29.2646C13.8296 28.5886 14.7309 28.4008 15.4445 28.889C17.3597 30.2034 19.6505 30.917 21.9789 30.917C28.3632 30.917 33.5457 25.6969 33.5457 19.2751C33.5457 12.8533 28.3632 7.63325 21.9789 7.63325C15.7449 7.63325 10.6375 12.628 10.4122 18.862L13.9047 15.3319C14.5056 14.731 15.4445 14.731 16.0453 15.3319C16.6462 15.9328 16.6462 16.8716 16.0453 17.4725L10.2995 23.2183C9.99908 23.5187 9.62353 23.669 9.24799 23.669C8.83489 23.669 8.45935 23.5187 8.19647 23.2183L2.45065 17.4349C1.84978 16.8341 1.84978 15.8952 2.45065 15.2943C3.05152 14.6935 3.99038 14.6935 4.59125 15.2943L7.44538 18.186C7.97114 10.6376 14.2803 4.62891 21.9789 4.62891C30.0155 4.62891 36.55 11.2009 36.55 19.2751ZM21.9038 10.7503C21.0776 10.7503 20.4016 11.4262 20.4016 12.2524V19.2751C20.4016 19.6882 20.5894 20.0637 20.8898 20.3266L24.1195 23.5563C24.4199 23.8567 24.7955 24.0069 25.2086 24.0069C25.5841 24.0069 25.9972 23.8567 26.2601 23.5563C26.861 22.9554 26.8234 22.0166 26.2226 21.4157L23.406 18.6367V12.2524C23.406 11.4262 22.73 10.7503 21.9038 10.7503Z",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11656_14543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 38,
    height: 38,
    rx: 4,
    fill: "white"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip1_11656_14543"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 34.55,
    height: 34.55,
    fill: "white",
    transform: "translate(2 2)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTimeIcon);
export default __webpack_public_path__ + "static/media/timeIcon.410e458e0fa397f558ef1d2dd4922b6a.svg";
export { ForwardRef as ReactComponent };